module.exports = __webpack_public_path__ + "static/img/trt.42f0327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/clients/trt.png
// module id = 5TZA
// module chunks = 1